



























import { editFactory } from '@/main/pages';
import _ from 'lodash';

import { store } from './store/edit';
import { NAME } from './constants';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	methods: {
		async saveClick() {
			this.startLoading();
			this.PaPrp = true;
			this.CvPrp = true;
			this.OstatnizakazkyPrp = true;
			if (await this.validate()) {
				const { data: isUnique } = await apiProvider.IsUnique(this.ExtkodNr!, this.VyrobekvozOzn!);
				if (isUnique) {
					await this.save();
				} else {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('duplicateEoCode'),
						options: { type: 'error' },
						localizeMessage: false,
					});
				}
			}
			this.endLoading();
		},
	},
});


